export default "__VITE_ASSET__Uxp6AVc0__"